module.exports = __webpack_public_path__ + "static/img/logo_tea.7b5c6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img/logo_tea.png
// module id = BfvP
// module chunks = 0